import GET_ARTICLES from "../plugins/getArticles"

const [ w, d, l ] = [ window, document, location ];

const init = () => {
  // recommend
  $.when( w.load['service'] ).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}" class="recommend-item">
        <figure class="recommend-item__img">
          <div class="recommend-item__img-cover"><img src="${item.thumb}" alt="${item.title}" width=""></div>
        </figure>
        <div class="recommend-item__body">
          ${item.is_new ? '<span class="new">NEW</span>': ''}
          <span class="cat">${item.category.name}</span>
          <h4 class="name">${item.title}</h4>
          <p class="desc">${item.desc}</p>
        </div>
      </a>
    `)[0]
    GET_ARTICLES('.service-recommend__list[data-plugin="getArticles"]',{ makeItem })
  });
};

//塗り替え相談室LP
const lp_init = () => false;

export default function SERVICE () {
  (/article=2/.test(l.search)) ? $( lp_init ): $( init );
}